import type { FC } from 'react';

import './LeadsLoadedCount.scss';

interface LeadsLoadedCountProps {
  loadedCount: number;
  totalCount: number;
}

export const LeadsLoadedCount: FC<LeadsLoadedCountProps> = ({
  loadedCount,
  totalCount,
}) => (
  <span className="LeadsLoadedCount">
    Загружено лидов: {loadedCount} из {totalCount}
  </span>
);
